import { render, staticRenderFns } from "./AccountOtherCommunication.vue?vue&type=template&id=3ba54d74&"
import script from "./AccountOtherCommunication.vue?vue&type=script&lang=js&"
export * from "./AccountOtherCommunication.vue?vue&type=script&lang=js&"
import style0 from "./AccountOtherCommunication.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports